import React, { Component } from "react";
import { withGoogleMap, GoogleMap } from "react-google-maps";
import "./Map.css";
class Map extends Component {
  render() {
    if (
      this.props.location.lat === undefined ||
      this.props.location.long === undefined
    ) {
      return (
        <div>
          <div
            className="mapcontainer"
            style={{
              backgroundColor: " #f6f8fa",
              verticalAlign: "middle",
              textAlign: "center"
            }}
          >
            {" "}
            <h3 style={{ lineHeight: "500px", color: "#b0b0b0" }}>
              {" "}
              Map not found.
            </h3>
          </div>
        </div>
      );
    }
    console.log(this.props.location.lat);
    console.log(this.props.location.long);
    var center = {
      lat: parseFloat(this.props.location.lat),
      lng: parseFloat(this.props.location.long)
    };
    var GoogleMapExample = withGoogleMap(props => (
      <GoogleMap defaultCenter={center} defaultZoom={15} />
    ));
    console.log("render");
    return (
      <div>
        <GoogleMapExample
          containerElement={<div className="mapcontainer" />}
          mapElement={<div style={{ height: `100%` }} />}
        />
      </div>
    );
  }
}

export default Map;



// WEBPACK FOOTER //
// ./src/components/Map/Map.js